import { render, staticRenderFns } from "./poPriceHistory.vue?vue&type=template&id=0556109e&"
import script from "./poPriceHistory.vue?vue&type=script&lang=js&"
export * from "./poPriceHistory.vue?vue&type=script&lang=js&"
import style0 from "./poPriceHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "poPriceHistory.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
